import React, { FC } from 'react'
import { Fade, FadeProps } from '@mui/material'

const EvtFade: FC<FadeProps> = ({ children, ...props }) => {
    return <Fade {...props}>{children}</Fade>
}

export default EvtFade
